import { createContext, useContext, useState, useEffect } from 'react'
import { authService } from '../services/api'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
    const [usuario, setUsuario] = useState(null)
    const [carregando, setCarregando] = useState(true)

    useEffect(() => {
        // Verificar se há usuário logado e buscar dados atualizados
        const verificarUsuario = async () => {
            const token = localStorage.getItem('token')
            if (token) {
                try {
                    // Buscar dados atualizados do servidor
                    const response = await authService.getUsuarioLogado()
                    setUsuario(response.usuario)
                    // Atualizar localStorage com dados frescos
                    localStorage.setItem('usuario', JSON.stringify(response.usuario))
                } catch (error) {
                    console.error('Erro ao buscar usuário:', error)
                    // Se falhar devido a erro de autenticação (token já limpo pelo client), não usar fallback
                    if (!localStorage.getItem('token')) {
                        setUsuario(null)
                    } else {
                        // Se for outro erro (ex: rede offline/servidor 502), usar dados do localStorage como fallback temporário
                        const usuarioSalvo = authService.getUsuario()
                        if (usuarioSalvo) {
                            setUsuario(usuarioSalvo)
                        } else {
                            authService.logout()
                        }
                    }
                }
            }
            setCarregando(false)
        }

        verificarUsuario()
    }, [])

    const login = async (email, senha) => {
        const response = await authService.login(email, senha)
        setUsuario(response.usuario)
        return response
    }

    const loginGoogle = async (credential) => {
        const response = await authService.loginGoogle(credential)
        setUsuario(response.usuario)
        if (response.isNovoUsuario) {
            localStorage.setItem(`termo_obrigatorio_${response.usuario.id}`, 'true')
        }
        return response
    }

    const cadastro = async (dados) => {
        const response = await authService.cadastro(dados)
        setUsuario(response.usuario)
        localStorage.setItem(`termo_obrigatorio_${response.usuario.id}`, 'true')
        return response
    }

    const logout = () => {
        authService.logout()
        setUsuario(null)
    }

    // Função para atualizar dados do usuário
    const atualizarUsuario = (dadosAtualizados) => {
        const novoUsuario = { ...usuario, ...dadosAtualizados }
        setUsuario(novoUsuario)
        localStorage.setItem('usuario', JSON.stringify(novoUsuario))
    }

    const value = {
        usuario,
        carregando,
        isLogado: !!usuario,
        login,
        loginGoogle,
        cadastro,
        logout,
        atualizarUsuario
    }

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext)
    if (!context) {
        throw new Error('useAuth deve ser usado dentro de AuthProvider')
    }
    return context
}

export default AuthContext
